import {Component, OnInit} from '@angular/core';
import {AlertService, JhiLanguageService} from 'ng-jhipster';
import {TranslateService} from 'ng2-translate';

import {JhiArchiveService} from './archive.service';
import {Archive} from './archive.model';
import {ConfirmationService} from 'primeng/components/common/api';
import {Fichier} from './fichier.model';
import {Observable} from 'rxjs/Observable';


@Component({
    selector: 'jhi-archive',
    templateUrl: './archive.component.html',

})
export class JhiArchiveComponent implements OnInit {
    archive: Archive = null;
    listeRepertoire: Array<Fichier> = null;
    filter: string;
    isLoading = false;
    disableArchive = false;
    public archivageEnCoursDepuis: String = null;
    public archivageEnCours: Boolean = false;

    constructor(private jhiLanguageService: JhiLanguageService,
                private archiveService: JhiArchiveService,
                private confirmationService: ConfirmationService,
                private translateService: TranslateService,
                private alertService: AlertService) {
        this.jhiLanguageService.setLocations(['archive']);
        this.filter = '';
    }

    ngOnInit() {
        this.refreshStatusArchivage.call(this) ;
        this.refreshArchive.call(this);
    }

    refreshStatusArchivage() {
        this.archiveService.getStatusArchivage().subscribe(
            (statusArchivage) => {
                // date de lancement non null -> archivage en cours sur back end
                if (statusArchivage.dateDeLancement != null) {
                    this.archivageEnCoursDepuis = ( (+(new Date()) - +(statusArchivage.dateDeLancement)) / 1000).toFixed();
                    // si il y avait pas scrutation périodique en cours en front end on lance la scrutation périodique
                    if (this.archivageEnCours == false) {
                        this.archivageEnCours = true ;
                        Observable.interval(5000).takeWhile(() => this.archivageEnCours == true)
                            .subscribe(() => this.refreshStatusArchivage());
                    }
                } else {

                    // si pas de scrutation périodique on met a zéro la valeur du compteur
                    if (this.archivageEnCours == false) {
                        this.archivageEnCoursDepuis = null ;
                    } else {
                        // on arrete scrutation périodique
                        this.archivageEnCours = false ;
                        this.refreshArchive.call(this);
                    }
                }
             },
            (archive) => {
                this.alertService.error(archive, null, null);
            });
    }


    refreshArchive() {
        this.isLoading = true;
        this.archiveService.get('0').subscribe(
            (archive) => {
                this.isLoading = false;
                this.archive = archive;
                this.ordonneArchive(this.archive.fichier);
                if (this.archive.anneeCourante != null && this.archivageEnCours == false) {
                    this.metAJourFlagSuppression(this.archive.fichier, this.archive.anneeCourante.toString());
                }
                this.listeRepertoire = this.archive.fichier.listeRepertoire;
            },
            (archive) => {
                this.isLoading = false;
                this.alertService.error(archive, null, null);
            });
    }

    onRefreshTreeView(refresh: boolean) {
        this.refreshArchive.call(this);
    }

    ordonneArchive(fichier: Fichier) {
        if (fichier != null) {
            if (fichier.listeSimpleFichier != null) {
                fichier.listeSimpleFichier.sort((a, b) => a.nom.localeCompare(b.nom));
            }
            if (fichier.listeRepertoire != null) {
                fichier.listeRepertoire.forEach(repertoire => this.ordonneArchive(repertoire));
            }
        }
    }

    metAJourFlagSuppression(fichier: Fichier, debutNom: string  ) {
        if (fichier != null) {
            if (fichier.nom.startsWith(debutNom)) {
                fichier.peuxEtreSupprime = true;
            }
            if (fichier.listeRepertoire != null) {
                fichier.listeRepertoire.forEach(repertoire => this.metAJourFlagSuppression(repertoire, debutNom));
            }
        }
    }

    archiveAnneeCourante() {
        this.confirmationArchive();
    }

    confirmationArchive() {
        this.confirmationService.confirm({
            message: this.translateService.instant('archive.confirm.question'),
            header: this.translateService.instant('archive.confirm.title'),
            icon: 'fa fa-archive',
            accept: () => {
                this.disableArchive = true;
                this.isLoading = true;
                this.archivageEnCours = true ;
                Observable.interval(5000).takeWhile(() => this.archivageEnCours == true).subscribe(() => this.refreshStatusArchivage());
                this.archiveService.archiveAnneecourante().subscribe(
                    (archive) => {
                        // archivage lancé--> la fonction refreshStatusArchivage est appelée périodiquement
                     },
                    (archive) => {
                        this.isLoading = false;
                        this.archivageEnCours = false ;
                        this.alertService.error(archive, null, null);
                    });
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/archive/archive.component.ts